export const isClickOutside = (el, target) => {
    return !(el === target || el.contains(target));
};
